import { render, staticRenderFns } from "./vroom.vue?vue&type=template&id=2ba1299c&lang=pug"
import script from "./vroom.vue?vue&type=script&lang=ts"
export * from "./vroom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports